var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as VariantFactory from "../../classes/definitions/product/variant";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import VariantsList from '../../components/Variants/VariantsList/VariantsList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./VariantsReduxProps";
var Variants = /** @class */ (function (_super) {
    __extends(Variants, _super);
    function Variants() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllVariants = function () {
            _this.api.getVariants(_this.parentId)
                .then(function (response) {
                var values = VariantFactory.createVariants(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: values, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим варианта.', _this.props.history);
            });
        };
        _this.toNewVariant = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.variant.path);
        };
        _this.toEditVariant = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.variant.path + ("/" + selectedId));
            }
        };
        _this.toParentProduct = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId);
        };
        return _this;
    }
    Variants.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        if (this.parentId !== '-1') {
            this.getAllVariants();
        }
    };
    Variants.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewVariant, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0432\u0430\u0440\u0438\u0430\u043D\u0442"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(VariantsList, { gridData: data, edit: this.toEditVariant, meta: meta, getAllVariants: this.getAllVariants }))))));
    };
    return Variants;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(Variants);



//////////////////
// WEBPACK FOOTER
// ./src/views/Variants/Variants.tsx
// module id = 507
// module chunks = 0